import React from 'react';
import { Card, Tag, Button, Space, Typography } from 'antd';
import { DeleteOutlined, CalculatorOutlined } from '@ant-design/icons';

const { Text } = Typography;

const AggregateCard = ({ aggregate, onRemove }) => {
  const getFunctionIcon = (func) => {
    switch (func) {
      case 'SUM':
        return '∑';
      case 'AVG':
        return '∅';
      case 'MIN':
        return '↓';
      case 'MAX':
        return '↑';
      case 'COUNT':
        return '#';
      case 'COUNT_DISTINCT':
        return '#*';
      default:
        return 'f';
    }
  };

  const getFunctionColor = (func) => {
    switch (func) {
      case 'SUM':
        return 'green';
      case 'AVG':
        return 'blue';
      case 'MIN':
        return 'orange';
      case 'MAX':
        return 'red';
      case 'COUNT':
        return 'purple';
      case 'COUNT_DISTINCT':
        return 'cyan';
      default:
        return 'default';
    }
  };

  return (
    <Card
      size="small"
      style={{
        border: '1px solid #d3adf7',
        backgroundColor: '#f9f0ff'
      }}
      bodyStyle={{ padding: '12px' }}
    >
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <Space align="center" style={{ width: '100%', justifyContent: 'space-between' }}>
          <Space align="center">
            <CalculatorOutlined style={{ color: '#722ed1' }} />
            <Text strong style={{ fontSize: '14px', color: '#722ed1' }}>
              {aggregate.alias}
            </Text>
          </Space>
          <Button
            type="text"
            size="small"
            icon={<DeleteOutlined />}
            onClick={onRemove}
            danger
            style={{ padding: '2px' }}
          />
        </Space>

        <Space size="small" wrap>
          <Tag color={getFunctionColor(aggregate.function)}>
            <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
              {getFunctionIcon(aggregate.function)}
            </span>
            {aggregate.function}
          </Tag>
        </Space>

        <Text type="secondary" style={{ fontSize: '12px' }}>
          Field: {aggregate.field}
        </Text>
      </Space>
    </Card>
  );
};

export default AggregateCard;